var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
// Used when the page gives no style (see views._map_style_url).
var FALLBACK_STYLE = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';
var MAX_MARKERS = 500;
/** Only plain http(s) or site-relative links: the url went through the model, so nothing else is trusted. */
function safeUrl(url) {
    if (typeof url !== 'string' || !url)
        return null;
    if (url.charAt(0) === '/' && url.charAt(1) !== '/')
        return url;
    return /^https?:\/\//i.test(url) ? url : null;
}
/** The markers of a map block, minus anything that is not a real position. */
function validMarkers(config) {
    var raw = config && Array.isArray(config.markers) ? config.markers : [];
    var markers = [];
    for (var i = 0; i < raw.length && markers.length < MAX_MARKERS; i++) {
        var m = raw[i];
        var c = m && Array.isArray(m.coordinates) ? m.coordinates : null;
        if (!c || c.length < 2)
            continue;
        var lng = Number(c[0]);
        var lat = Number(c[1]);
        if (!isFinite(lng) || !isFinite(lat) || Math.abs(lng) > 180 || Math.abs(lat) > 90)
            continue;
        var value = typeof m.value === 'number' && isFinite(m.value) ? m.value : null;
        markers.push({ lng: lng, lat: lat, label: typeof m.label === 'string' ? m.label : '', url: safeUrl(m.url), value: value });
    }
    return markers;
}
/**
 * A map of customers. The block holds {markers: [{coordinates: [lng, lat], label, url}]}: the
 * server fills it in from the get_map_points result (mcp_client.expand_map_blocks), the model
 * only names that result. The map fits itself to the markers, so a made-up centre or zoom is
 * never used; every marker has one style and opens a popup whose label links to the record.
 */
var MapBlock = /** @class */ (function (_super) {
    __extends(MapBlock, _super);
    function MapBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.error = null;
        _this.valueLabel = '';
        _this.map = null;
        _this.observer = null;
        return _this;
    }
    MapBlock.prototype.mounted = function () {
        this.build();
    };
    MapBlock.prototype.beforeDestroy = function () {
        if (this.observer)
            this.observer.disconnect();
        this.observer = null;
        if (this.map) {
            try {
                this.map.remove();
            }
            catch (e) {
                /* already gone */
            }
            this.map = null;
        }
    };
    MapBlock.prototype.build = function () {
        var _this = this;
        var config;
        try {
            config = JSON.parse(this.spec);
        }
        catch (e) {
            console.error('AI chat map: invalid JSON', e);
            this.error = this.errorText;
            return;
        }
        if (typeof mapboxgl === 'undefined') {
            console.error('AI chat map: mapbox-gl is not loaded');
            this.error = this.errorText;
            return;
        }
        var markers = validMarkers(config);
        this.valueLabel = typeof config.value_label === 'string' ? config.value_label : '';
        if (!markers.length) {
            this.error = this.noPointsText;
            return;
        }
        this.$nextTick(function () {
            var el = _this.$refs.container;
            if (!el)
                return;
            try {
                // The library insists on a token even for tile sources that do not need one.
                mapboxgl.accessToken = _this.mapConfig.accessToken || 'pk.not_required_for_other_tiles';
                var bounds_1 = new mapboxgl.LngLatBounds();
                markers.forEach(function (m) { return bounds_1.extend([m.lng, m.lat]); });
                var map_1 = new mapboxgl.Map({
                    container: el,
                    style: _this.mapConfig.styleUrl || FALLBACK_STYLE,
                    center: [markers[0].lng, markers[0].lat],
                    zoom: 9,
                });
                var fit_1 = function () { return map_1.fitBounds(bounds_1, { padding: 48, maxZoom: 15, duration: 0 }); };
                fit_1();
                map_1.on('load', function () {
                    map_1.resize();
                    fit_1();
                });
                map_1.on('error', function (e) { return console.error('AI chat map:', e && e.error ? e.error : e); });
                map_1.addControl(new mapboxgl.NavigationControl(), 'top-right');
                markers.forEach(function (m) {
                    var dot = document.createElement('div');
                    dot.className = 'ai-map-marker';
                    if (m.label)
                        dot.title = m.label;
                    var popup = new mapboxgl.Popup({ offset: 10 }).setDOMContent(_this.popupContent(m));
                    new mapboxgl.Marker(dot).setLngLat([m.lng, m.lat]).setPopup(popup).addTo(map_1);
                });
                // The canvas is sized once on creation; re-measure when its container changes.
                var Observer = window.ResizeObserver;
                if (Observer) {
                    _this.observer = new Observer(function () { return map_1.resize(); });
                    _this.observer.observe(el);
                }
                _this.map = map_1;
            }
            catch (e) {
                console.error('AI chat map could not be rendered:', e);
                _this.error = _this.errorText;
            }
        });
    };
    MapBlock.prototype.popupContent = function (marker) {
        var box = document.createElement('div');
        box.className = 'ai-map-popup';
        var text = marker.label || '#';
        if (marker.url) {
            var link = document.createElement('a');
            link.href = marker.url;
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = text;
            box.appendChild(link);
        }
        else {
            box.textContent = text;
        }
        if (marker.value !== null) {
            var value = document.createElement('div');
            value.className = 'ai-map-popup-value';
            var formatted = new Intl.NumberFormat(navigator.language || undefined, { maximumFractionDigits: 2 }).format(marker.value);
            value.textContent = this.valueLabel ? "".concat(this.valueLabel, ": ").concat(formatted) : formatted;
            box.appendChild(value);
        }
        return box;
    };
    __decorate([
        Prop({ type: String, required: true })
    ], MapBlock.prototype, "spec", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], MapBlock.prototype, "errorText", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], MapBlock.prototype, "noPointsText", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({ styleUrl: '', accessToken: '' }); } })
    ], MapBlock.prototype, "mapConfig", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], MapBlock.prototype, "wide", void 0);
    MapBlock = __decorate([
        Component
    ], MapBlock);
    return MapBlock;
}(Vue));
export default MapBlock;
